module.exports = __webpack_public_path__ + "static/media/header-img.6fd63d93.svg";